module.exports = __webpack_public_path__ + "lb.svg?76c19d92a9bdd75f7902587ff7e27911";